const instructors_data = [
    {
        id:1,
        img:'instructor-01.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Yusuf Kuvvetli',
        title:'Doç. Dr.',
        delay:'50',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:2,
        img:'instructor-02.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'İrem Kuvvetli',
        title:'Dr. Öğr. Üyesi',
        delay:'100',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:3,
        img:'instructor-03.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Adem Erik',
        title:'Dr. Öğr. Üyesi',
        delay:'150',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:4,
        img:'instructor-04.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Sakhi M. Hamidy',
        title:'Arş. Gör. Dr.',
        delay:'200',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:5,
        img:'instructor-05-2.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Ümit Yıldırım',
        title:'Endüstri Yük. Müh.',
        delay:'250',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:6,
        img:'instructor-empty.png',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Betül Çetin',
        title:'Endüstri Yük. Müh.',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:7,
        img:'instructor-empty.png',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Kübra Mete',
        title:'Endüstri Müh.',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    }
]

export const yoga_instructor = [
    {
        id:1,
        img:'team-01.webp',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Nancy Dew',
        title:'Yoga Trainer',
        delay:'50',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:2,
        img:'team-02.webp',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Jared Hayes',
        title:'Yoga Trainer',
        delay:'100',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    },
    {
        id:3,
        img:'team-03.webp',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Rebecca Roye',
        title:'Yoga Trainer',
        delay:'150',
        sm_text:"Consectetur adipisicing elit, sed do eius mod tempor incididunt"
    }
];

export default instructors_data;